(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  // Keep the cart link as a no-JavaScript fallback. On desktop, Shopify's
  // cart drawer is available, so the normal click must open it in place.
  if (!window.__mvDesktopCartDrawerBound) {
    window.__mvDesktopCartDrawerBound = true;
    document.addEventListener('click', (event) => {
      const cartLink = event.target.closest('.header__icon--cart');
      if (!cartLink || !window.matchMedia('(min-width: 991px)').matches) return;

      const drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.open !== 'function') return;

      event.preventDefault();
      drawer.open(cartLink);
    }, true);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["miravel-veria-ugc-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('miravel-veria-ugc')) {
    customElements.define('miravel-veria-ugc', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-ugc-track]');
        this.previous = this.querySelector('[data-ugc-prev]');
        this.next = this.querySelector('[data-ugc-next]');
        if (!this.track) return;
        if (this.initialized) return;
        this.initialized = true;
        this.setupLoop();
        this.previous?.addEventListener('click', () => this.scroll(-1));
        this.next?.addEventListener('click', () => this.scroll(1));
        this.imageObserver = new IntersectionObserver((entries) => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.track.querySelectorAll('img').forEach(image => {
            image.loading = 'eager';
            image.decode?.().catch(() => {});
          });
          this.imageObserver.disconnect();
        }, { rootMargin: '400px 0px' });
        this.imageObserver.observe(this.track);
      }

      setupLoop() {
        const cards = [...this.track.querySelectorAll('.mv-veria-ugc__card')];
        if (cards.length < 2) return;

        const before = document.createDocumentFragment();
        const after = document.createDocumentFragment();
        cards.forEach((card) => {
          const beforeClone = card.cloneNode(true);
          const afterClone = card.cloneNode(true);
          beforeClone.setAttribute('aria-hidden', 'true');
          afterClone.setAttribute('aria-hidden', 'true');
          before.appendChild(beforeClone);
          after.appendChild(afterClone);
        });
        this.track.prepend(before);
        this.track.append(after);

        this.primaryCards = [...this.track.querySelectorAll('.mv-veria-ugc__card:not([aria-hidden])')];
        this.firstPrimary = this.primaryCards[0];
        this.firstAfter = this.primaryCards[this.primaryCards.length - 1].nextElementSibling;
        requestAnimationFrame(() => {
          this.loopStart = this.firstPrimary.offsetLeft;
          this.loopWidth = this.firstAfter.offsetLeft - this.loopStart;
          this.jumpTo(this.loopStart);
        });
        const settle = () => {
          clearTimeout(this.loopTimer);
          this.loopTimer = setTimeout(() => this.wrapLoop(), 180);
        };
        this.track.addEventListener('scroll', settle, { passive: true });
        this.track.addEventListener('touchstart', () => {
          this.touching = true;
          clearTimeout(this.loopTimer);
        }, { passive: true });
        const release = () => { this.touching = false; settle(); };
        this.track.addEventListener('touchend', release, { passive: true });
        this.track.addEventListener('touchcancel', release, { passive: true });
        this.resizeObserver = new ResizeObserver(() => {
          this.loopStart = this.firstPrimary.offsetLeft;
          this.loopWidth = this.firstAfter.offsetLeft - this.loopStart;
          settle();
        });
        this.resizeObserver.observe(this.track);
      }

      wrapLoop() {
        if (!this.loopWidth || this.isJumping || this.touching) return;
        if (this.track.scrollLeft < this.loopStart - 2) {
          this.jumpTo(this.track.scrollLeft + this.loopWidth);
        } else if (this.track.scrollLeft >= this.loopStart + this.loopWidth) {
          this.jumpTo(this.track.scrollLeft - this.loopWidth);
        }
      }

      jumpTo(position) {
        this.isJumping = true;
        const behavior = this.track.style.scrollBehavior;
        const snap = this.track.style.scrollSnapType;
        this.track.style.scrollBehavior = 'auto';
        this.track.style.scrollSnapType = 'none';
        this.track.scrollLeft = position;
        requestAnimationFrame(() => requestAnimationFrame(() => {
          this.track.style.scrollBehavior = behavior;
          this.track.style.scrollSnapType = snap;
          this.isJumping = false;
        }));
      }

      scroll(direction) {
        const card = this.track.querySelector('.mv-veria-ugc__card');
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const amount = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth * .8;
        this.track.scrollBy({ left: amount * direction, behavior: 'smooth' });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
